import React from "react";
import UiTablePageToolbar from "./UiTablePageToolbar";
import UiTableCardHeader from "./UiTableCardHeader";

const UiDataTable = ({
  toolbarLeading = null,
  toolbarTrailing = null,
  onSearch,
  searchValue,
  searchPlaceholder = "Search",
  showSearch = true,
  searchAlign = "auto",
  title,
  subtitle,
  count,
  countSuffix = "records",
  headerExtra,
  showHeader,
  shellClassName,
  children,
}) => {
  const hasToolbar =
    (showSearch && onSearch) || toolbarLeading || toolbarTrailing;
  const hasHeader =
    showHeader !== false &&
    (title || subtitle || count != null || count !== "" || headerExtra);
  const fillPageHeight =
    shellClassName?.includes("reception-patient-list-shell") ||
    shellClassName?.includes("ui-table-fill-shell");

  const tableShell = (
    <div
      className={["ui-table-shell", shellClassName].filter(Boolean).join(" ")}
    >
      {hasHeader ? (
        <UiTableCardHeader
          title={title}
          subtitle={subtitle}
          count={count}
          countSuffix={countSuffix}
          extra={headerExtra}
        />
      ) : null}
      {children}
    </div>
  );

  const pageContent = (
    <>
      {hasToolbar ? (
        <UiTablePageToolbar
          leading={toolbarLeading}
          trailing={toolbarTrailing}
          onSearch={onSearch || (() => {})}
          searchValue={searchValue}
          placeholder={searchPlaceholder}
          searchAlign={searchAlign}
          showSearch={showSearch && Boolean(onSearch)}
        />
      ) : null}
      {tableShell}
    </>
  );

  if (fillPageHeight) {
    return <div className="ui-table-page-fill">{pageContent}</div>;
  }

  return pageContent;
};

export default UiDataTable;
